import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import CountdownTimer from "./CountDownTimer";
import { usePromo } from "./providers/Init";
import { useNavigate } from "react-router-dom";
import frameImage from "./assets/wheel/frame.png";
import spinningImage from "./assets/wheel/spinning.png";

const preloadImages = (imageUrls) => {
  return Promise.allSettled(
    imageUrls.map((url) => {
      return new Promise((resolve, reject) => {
        const img = new Image();
        img.src = url;
        img.onload = resolve;
        img.onerror = reject;
      });
    })
  );
};

const PromoOverlay = () => {
  const { t } = useTranslation(); // Подключаем перевод
  const [isVisible, setIsVisible] = useState(false);
  const [isFading, setIsFading] = useState(false);
  const [isDFading, setIsDFading] = useState(false);
  const [rotation, setRotation] = useState(0);
  const [spinning, setSpinning] = useState(false);
  const [showResult, setShowResult] = useState(false);
  const [loaded, setLoaded] = useState(false);
  const images = ["/wheel/frame.png", "/wheel/spinning.png"];

  useEffect(() => {
    preloadImages(images).then(() => setLoaded(true));
  }, []);

  const promo = usePromo();
  const percentage = (100 - promo * 100) || 50;

  useEffect(() => {
    const isPromoDismissed = localStorage.getItem("promoDismissed");
    if (!isPromoDismissed) {
      setIsVisible(true);
    }
  }, []);

  const getFixedAngle = (percentage) => {
    switch (percentage) {
      case 50:
        return 3660;
      case 70:
        return 3540;
      case 90:
        return 3420;
      default:
        return 3660;
    }
  };

  const spinWheel = () => {
    if (spinning) return;
    setSpinning(true);

    const fixedAngle = getFixedAngle(percentage);
    setRotation(rotation + fixedAngle);

    setTimeout(() => {
      setIsFading(true);
      setTimeout(() => {
        setShowResult(true);
        setIsFading(false);
      }, 1000);
    }, 5000);
  };

  const navigate = useNavigate();
  const handleClose = () => {
    setIsDFading(true);
    setTimeout(() => {
      setIsVisible(false);
      localStorage.setItem("promoDismissed", "true");
    }, 500);
  };

  if (!loaded) {
    return (
      <div className="fixed top-0 bottom-0 left-0 right-0 flex items-center justify-center bg-white">
        <div className="animate-pulse">{t("loading")}</div>
      </div>
    );
  }

  return (
    isVisible && (
      <div className={`fixed z-50 flex items-center justify-center w-full h-screen p-8 bg-black bg-opacity-10 transition-opacity duration-500 ${isDFading ? "opacity-0" : "opacity-100"}`}>
        <div className={`absolute z-50 flex items-center justify-center w-full h-screen p-8 ${isFading ? "opacity-0" : "opacity-100"} transition-opacity duration-500`}>
          <div className="flex flex-col items-center overflow-hidden w-full max-w-md p-6 bg-white shadow-lg rounded-xl">
            {!showResult ? (
              <>
                <div className="flex justify-center w-[700px] overflow-auto bg-yellow-300 -rotate-6 shadow mt-4">
                  <span className="text-center w-[700px] font-black text-xl">
                    {t("promotion")}
                  </span>
                </div>
                <div className="flex justify-center w-[700px] overflow-auto bg-yellow-300 relative -top-4 shadow rotate-3">
                  <span className="text-center w-[700px] font-black text-xl">
                    {t("promotion")}
                  </span>
                </div>
                <div className="px-6 pb-6 text-center">
                  <p className="mb-4 text-xl text-gray-700" dangerouslySetInnerHTML={{ __html: t("spin_wheel") }} />
                  <div className="relative flex items-center justify-center w-full">
                    <img className="absolute z-50 scale-125" src={frameImage} alt="Frame" />
                    <img
                      className="w-full transition-transform duration-[3500ms] ease-in-out"
                      src={spinningImage}
                      alt="Wheel"
                      style={{ transform: `rotate(${rotation}deg)` }}
                    />
                  </div>
                  <p className="mt-10 text-xs text-gray-500">{t("hurry_offer")}</p>
                  <button
                    className="w-full px-6 py-3 mt-6 text-lg font-semibold text-white rounded-lg bg-prim_blue hover:bg-yellow-600"
                    onClick={spinWheel}
                  >
                    {t("spin_button")}
                  </button>
                </div>
              </>
            ) : (
              <div className="text-center transition-opacity duration-1000 opacity-100">
                <p className="mb-4 text-xl text-gray-700" dangerouslySetInnerHTML={{ __html: t("congratulations", { percentage }) }} />
                <CountdownTimer />
                <p className="mt-2 text-gray-700 text-md">{t("act_fast")}</p>
                <button
                  className="w-full px-6 py-3 mt-6 text-lg font-semibold text-white rounded-lg bg-prim_blue hover:bg-yellow-600"
                  onClick={handleClose}
                >
                  {t("claim_prize")}
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    )
  );
};

export default PromoOverlay;
